import { render, staticRenderFns } from "./waybillDetail.vue?vue&type=template&id=8a10d3da&scoped=true"
import script from "./waybillDetail.vue?vue&type=script&lang=js"
export * from "./waybillDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a10d3da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a10d3da')) {
      api.createRecord('8a10d3da', component.options)
    } else {
      api.reload('8a10d3da', component.options)
    }
    module.hot.accept("./waybillDetail.vue?vue&type=template&id=8a10d3da&scoped=true", function () {
      api.rerender('8a10d3da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/handoverException/component/waybillDetail.vue"
export default component.exports